import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { ProductReviewQuote } from '../components/ProductReviewQuote';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';

export const SuperPowerThongLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-superpowerthong-lander-top-hero-1.jpg'}
          title={'SuperPower Thong'}
          subTitle={'Our most powerful shaping technology in a thong.'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Never <br /> rolls down
              </>
            }
            titleStyles={{ lineHeight: '18px', textAlign: 'right' }}
            inlineStyles={{
              mobile: {
                right: `60%`,
                top: `48%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={<>Targeted compression</>}
            inlineStyles={{
              mobile: {
                left: `52%`,
                bottom: `32%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={<>No panty lines</>}
            inlineStyles={{
              mobile: {
                left: `3%`,
                top: `70%`,
                flexDirection: 'row',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-spt-desktop-1.jpg',
              title: 'Waist Contouring',
              description: 'Targeted X compression sculpts without squeezing.',
            },
            {
              imgName: 'feature-spt-desktop-2.jpg',
              title: 'No Panty Lines',
              description: 'Thong bottom eliminates panty lines for a seamless look.',
            },
            {
              imgName: 'feature-spt-desktop-3.jpg',
              title: 'Stays Put',
              description: 'Flexible boning keeps the garment from rolling down.',
            },
          ]}
        />
        <ProductReviewQuote
          quoteText={'The SuperPower Thong was exactly as described and exceeded my expectations. This is the first product that did not roll down!!'}
          author="NIKKI P."
          imgName="superpower-thong-quote-mobile.jpg"
        />
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.SuperPowerThong]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SuperPowerThongLanderMobile;
